import './index.css';

import { Auth0Provider } from '@auth0/auth0-react';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const domain = 'menu-to-images.eu.auth0.com';
const clientId = 'ksVwLW6IAlmcGKazzr6oahVwGEghd9dB';
const redirectUri = window.location.origin;

// Debug PostHog configuration
console.log('PostHog Configuration:', {
  apiKey: process.env.REACT_APP_POSTHOG_KEY ? 'SET' : 'MISSING',
  host: process.env.REACT_APP_POSTHOG_HOST || 'MISSING',
  nodeEnv: process.env.NODE_ENV,
  reactEnv: process.env.REACT_APP_ENV,
  origin: window.location.origin,
});

const AppWithAuth0 = () => {
  return (
    <React.StrictMode>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: redirectUri,
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Auth0Provider>
    </React.StrictMode>
  );
};

const AppWithPostHog = () => {
  return (
    <React.StrictMode>
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: process.env.NODE_ENV === 'development',
        }}
      >
        <AppWithAuth0 />
      </PostHogProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV);
if (process.env.REACT_APP_ENV === 'production') {
  root.render(
    <React.StrictMode>
      <AppWithPostHog />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <AppWithAuth0 />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker in both development and production
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('Service worker registered successfully:', registration);

        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New service worker installed! Refresh to get latest version.');
              }
            });
          }
        });
      })
      .catch(err => {
        console.warn('Service worker registration failed:', err);
      });
  });
} else {
  console.log('Service worker not supported');
}
